import { getEdgeRegionHint } from '@atlassian/search-common';

import type { BootstrapVariables } from '../../../common/constants/relay/types';
import { serveRegionSteeringExperiment } from '../../../common/utils/experiments';

export function getRelayFetchOptions(bootstrap: BootstrapVariables):
	| {
			networkCacheConfig: {
				metadata: {
					headers: {
						'atl-edge-region-hint': string | undefined;
					};
				};
			};
	  }
	| undefined {
	if (serveRegionSteeringExperiment()) {
		const edgeRegionHint =
			bootstrap.primaryProduct && bootstrap.productDataRegions
				? getEdgeRegionHint(bootstrap.primaryProduct, bootstrap.productDataRegions)
				: undefined;

		return {
			networkCacheConfig: {
				metadata: {
					headers: {
						'atl-edge-region-hint': edgeRegionHint,
					},
				},
			},
		};
	} else {
		return undefined;
	}
}
